import { Box, Typography } from '@mui/material';

export const CardFlairVariants = {
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large',
} as const;

interface CardFlairProps {
  label?: string;
  variant?: (typeof CardFlairVariants)[keyof typeof CardFlairVariants];
}

export const CardFlair = ({
  label = 'New!',
  variant = 'medium',
}: CardFlairProps) => {
  const widths = {
    [CardFlairVariants.SMALL]: 120,
    [CardFlairVariants.MEDIUM]: 160,
    [CardFlairVariants.LARGE]: 200,
  } as const;

  const fontVariants = {
    [CardFlairVariants.SMALL]: 'caption1Bold',
    [CardFlairVariants.MEDIUM]: 'body3SemiBold',
    [CardFlairVariants.LARGE]: 'body2SemiBold',
  } as const;

  const pys = {
    [CardFlairVariants.SMALL]: 0,
    [CardFlairVariants.MEDIUM]: 0.25,
    [CardFlairVariants.LARGE]: 0.5,
  } as const;

  const width = widths[variant];
  const py = pys[variant];
  const fontVariant = fontVariants[variant];

  return (
    <Box
      sx={{
        position: 'absolute',
        textAlign: 'center',
        width,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        top: -width / 4,
        right: 0,
        py,
        transform: `rotate(45deg) translateX(${width / 2}px)`,
        background: theme => theme.palette.gradients.banner,
        boxShadow: theme => theme.customShadows.cardFlair,
      }}>
      <Typography
        component="span"
        variant={fontVariant}
        sx={{ color: 'text.contrast' }}>
        {label}
      </Typography>
    </Box>
  );
};
